import { RootState } from "@/store"

const selectLanguage = () => (state: RootState) => state.app.language
const selectIsLoaded = () => (state: RootState) => state.app.isLoaded
const selectIsDesktop = () => (state: RootState) => state.app.isDesktop
const selectIsPhoneDevice = () => (state: RootState) => state.app.isPhoneDevice
const selectScreen = () => (state: RootState) => state.app.screen
const selectReAuthState = () => (state: RootState) => state.app.reAuthState
const selectIsTMA = () => (state: RootState) => state.app.isTMA
const selectIsDevEnv = () => (state: RootState) => state.app.isDev

export const AppSelectors = {
  selectLanguage,
  selectIsLoaded,
  selectIsDesktop,
  selectIsPhoneDevice,
  selectScreen,
  selectReAuthState,
  selectIsTMA,
  selectIsDevEnv
}
